import { render, staticRenderFns } from "./Product_twt.vue?vue&type=template&id=6cd2904e&scoped=true&"
import script from "./Product_twt.vue?vue&type=script&lang=js&"
export * from "./Product_twt.vue?vue&type=script&lang=js&"
import style0 from "./Product_twt.vue?vue&type=style&index=0&id=6cd2904e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd2904e",
  null
  
)

export default component.exports